import React from "react";

import PlanOverview from "QuotePage/app/planDetails/PlanOverview";

import FinePrint from "Common/FinePrint";
import { SizeSwitch } from "Common/Responsive";

const SimplePlanDetails = ({ plan, className, planDetailsDisplay, showColoredDots, ...rest }) => (
  <div className={className}>
    <PlanOverview plan={plan} tableProperties="employee" {...rest} />
    <SizeSwitch
      md={
        <div>
          <FinePrint plan={plan} showColoredDots={false} />
        </div>
      }
      xs={<FinePrint plan={plan} isMobile showColoredDots={false} />}
    />
  </div>
);

export default SimplePlanDetails;
